// extracted by mini-css-extract-plugin
export default {"ceb-customer":"table-row_ceb-customer__YxQ6D","leco-customer":"table-row_leco-customer__2kK5c","disable":"table-row_disable__Jyj6T"};